import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectActors,
  selectSelectedElement,
  updateSelectedInteraction,
} from "../../../app/slices/TrainingSlice";
import { ISetOutfit } from "../../../models/interactions/SetOutfit";
import OutfitPickerField from "../../outfit_picker/OutfitPickerField";
import PiActorChipSelect from "../components/PiActorChipSelect";
import PiConnectorLabel from "../components/PiConnectorLabel";

/**
 * One sentence row, like Look At: "[actor] changes into → [outfit]", with the
 * outfit's render below it at the row's width. The chip and the render both
 * open the outfit picker.
 * Design: Design Studio `screens/set-outfit/e4-below.html`.
 */
export default function SetOutfitPreviewBody() {
  const dispatch = useDispatch();
  const interaction = useSelector(selectSelectedElement) as ISetOutfit;
  const { t } = useTranslation();
  const actors = useSelector(selectActors);

  const updateInteraction = (field: keyof ISetOutfit, value: any) => {
    dispatch(updateSelectedInteraction({ ...interaction, [field]: value }));
  };

  return (
    <div data-testid="set-outfit-row">
      <OutfitPickerField
        variant="chip"
        withStage
        rowStart={
          <>
            <PiActorChipSelect
              aria-label={String(t("set_outfit_ui.target"))}
              value={interaction.actorId}
              onChange={(id) => updateInteraction("actorId", id)}
            />
            <PiConnectorLabel text={String(t("set_outfit_ui.changes_into"))} />
          </>
        }
        context="setOutfit"
        actor={actors.find((actor) => actor.id === interaction.actorId)}
        value={interaction.outfitName ?? ""}
        onChange={(outfitName) => updateInteraction("outfitName", outfitName)}
      />
    </div>
  );
}
